export default {
  companyInfo: {}
};
